<div class="container-fluid px-4 py-3">

  <div class="row mb-4">
    <div class="col-12">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link active" href="#">Crear notificación</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/notificaciones']">Enviados</a>
        </li>
      </ul>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <form [formGroup]="notificationForm" (ngSubmit)="submitNotification()" class="needs-validation">
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <div class="form-group mb-3">
              <label for="title" class="form-label">Título de la notificación</label>
              <input 
                type="text" 
                id="title" 
                class="form-control" 
                formControlName="title" 
                [ngClass]="{'is-invalid': f['title'].touched && f['title'].errors}">
              <div class="invalid-feedback" *ngIf="f['title'].touched && f['title'].errors">
                El título de la notificación es requerido
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="message" class="form-label">Mensaje</label>
              <textarea 
                id="message" 
                class="form-control" 
                formControlName="message" 
                rows="5"
                [ngClass]="{'is-invalid': f['message'].touched && f['message'].errors}"></textarea>
              <div class="invalid-feedback" *ngIf="f['message'].touched && f['message'].errors">
                El mensaje de la notificación es requerido
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="notification_type" class="form-label">Tipo de notificación</label>
              <select 
                id="notification_type" 
                class="form-select" 
                formControlName="notification_type"
                [ngClass]="{'is-invalid': f['notification_type'].touched && f['notification_type'].errors}">
                <option value="info">Información</option>
                <option value="warning">Advertencia</option>
                <option value="success">Éxito</option>
                <option value="error">Error</option>
              </select>
              <div class="invalid-feedback" *ngIf="f['notification_type'].touched && f['notification_type'].errors">
                Debe seleccionar un tipo de notificación
              </div>
            </div>

            <div class="form-group mb-3">
              <label for="importance" class="form-label">Nivel de importancia</label>
              <select 
                id="importance" 
                class="form-select" 
                formControlName="importance"
                [ngClass]="{'is-invalid': f['importance'].touched && f['importance'].errors}">
                <option value="baja">Baja</option>
                <option value="media">Media</option>
                <option value="alta">Alta</option>
              </select>
              <div class="invalid-feedback" *ngIf="f['importance'].touched && f['importance'].errors">
                Debe seleccionar un nivel de importancia
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="recipient-section">
              <label class="form-label">¿A quién va dirigida?</label>

              <div class="form-group mb-3">
                <select class="form-select recipient-select mb-3" 
                        formControlName="recipientType"
                        (change)="onRecipientTypeChange($event)">
                  <option value="all">Todos los usuarios</option>
                  <option value="role">Por rol</option>
                  <option value="individual">Usuarios específicos</option>
                </select>

              </div>

              <!-- Selección por rol -->
              <div class="form-group mb-3" *ngIf="recipientType === 'role'">
                <label class="form-label">Seleccionar rol</label>
                <select class="form-select" formControlName="role">
                  <option value="">Seleccionar rol</option>
                  <option value="admin">Administrador</option>
                  <option value="teacher">Profesor</option>
                  <option value="analyst">Analista</option>
                  <option value="customer">Cliente</option>
                </select>
              </div>

              <!-- Selección de usuarios individuales -->
              <div class="form-group mb-3" *ngIf="recipientType === 'individual'">
                <label class="form-label">Usuarios específicos</label>
                
                <!-- Buscador de usuarios -->
                <div class="input-group mb-2">
                  <span class="input-group-text"><i class="bi bi-search"></i></span>
                  <input 
                    type="text" 
                    class="form-control" 
                    placeholder="Buscar usuario por nombre o email..."
                    [(ngModel)]="userSearchTerm"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="filterUsers()">
                </div>

                <!-- Lista de usuarios -->
                <div class="users-list" *ngIf="!loadingUsers">
                  <div *ngIf="filteredUsers.length === 0" class="alert alert-warning">
                    No se encontraron usuarios
                  </div>
                  
                  <div class="user-item" 
                       *ngFor="let user of filteredUsers" 
                       (click)="toggleUserSelection(user.id)"
                       [class.selected]="isUserSelected(user.id)">
                    <input 
                      type="checkbox" 
                      [checked]="isUserSelected(user.id)"
                      (click)="$event.stopPropagation()">
                    <div class="user-info">
                      <div class="user-name">{{ user.name }} {{ user.last_name }}</div>
                      <div class="user-email">{{ user.email }}</div>
                    </div>
                    <span class="badge bg-secondary">{{ user.role?.name || 'Sin rol' }}</span>
                  </div>
                </div>

                <div *ngIf="loadingUsers" class="text-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando usuarios...</span>
                  </div>
                </div>

                <!-- Contador de seleccionados -->
                <div class="mt-2" *ngIf="selectedUserIds.length > 0">
                  <span class="badge bg-primary">
                    {{ selectedUserIds.length }} usuario(s) seleccionado(s)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-4 gap-3">
          <button type="button" class="btn btn-secondary px-4" [routerLink]="['/notificaciones']">
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary px-5" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Enviando...' : 'Enviar Notificación' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
